module.exports = __webpack_public_path__ + "static/media/who-6.a04e060d.jpg";